import Constants from '@/Constants';
import { BadgeTranslation } from '@/models/BadgeTranslation';
import { PersonBadge } from '@/models/PersonBadge';
import { ApplicationState } from '@/store';
import { updateAchievementsNotificationRequest } from '@/store/achievements/actions';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/esm/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import './style.scss';

interface Props {
    achievement: PersonBadge;
    setAchievementAsRead: CallableFunction;
}

const AchievementModal: React.FC<Props> = ({ achievement, setAchievementAsRead }: Props) => {
    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const dispatch = useDispatch();
    const history = useHistory();
    const [currentBadgeTranslation, setCurrentBadgeTranslation] = useState<BadgeTranslation>();
    const [modalVisible, setModalVisible] = useState<boolean>(false);

    const { badge, id: personBadgeId } = achievement;
    const { badgeTranslations } = badge || ({} as BadgeTranslation);

    useEffect(() => {
        if (badgeTranslations) {
            setCurrentBadgeTranslation(badgeTranslations.find((bt: BadgeTranslation) => bt.locale === strings._LANGUAGE));
        }
    }, [strings._LANGUAGE, badgeTranslations]);

    useEffect(() => {
        if (achievement) {
            setModalVisible(true);
        }

        if (personBadgeId) {
            dispatch(updateAchievementsNotificationRequest(personBadgeId));
        }
    }, [achievement]);

    const getImage = (): string => {
        return `${Constants.imageFolders.STATIC_ASSETS_BADGES.replace('%k', badge.key)}${Constants.badgeImages.GRANTED_BG}` || '';
    };

    const closeAchievementModal = () => {
        setModalVisible(false);
        setAchievementAsRead(personBadgeId);
    };

    const goToAchievementsHandler = () => {
        setModalVisible(false);
        history.push(`/achievements`);
    };

    return (
        <>
            {currentBadgeTranslation && (
                <div className="achievement-modal">
                    <Modal backdrop={true} centered dialogClassName="modal-achievement" onHide={closeAchievementModal} show={modalVisible}>
                        <div className="body-modal" style={{ backgroundImage: `url(${getImage()})` }}>
                            <div className="achievement-modal__achievement-modal-body">
                                <div className="achievement-modal__achievement-modal-body__achievement-title">
                                    <h2 dangerouslySetInnerHTML={{ __html: currentBadgeTranslation.grantedTitle }} />
                                </div>
                                <div className="achievement-modal__achievement-modal-body__achievement-subtitle">
                                    <span dangerouslySetInnerHTML={{ __html: currentBadgeTranslation.grantedDescription }} />
                                </div>
                                <div className="achievement-modal__achievement-modal-body__buttons">
                                    <Button className="btn-achievements-handler" onClick={goToAchievementsHandler}>
                                        {strings.ACHIEVEMENTS.ACCESS_ACHIEVEMENTS}
                                    </Button>
                                    <Button className="btn-achievements-close" onClick={closeAchievementModal}>
                                        {strings.CLOSE}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            )}
        </>
    );
};

export default AchievementModal;
